
import './App.css';
import Home from './components/Home/Home.jsx';
import { Route, Routes } from "react-router-dom"
import About from './components/About/About.jsx';
import Stocks from './components/Stocks/Stocks.jsx';
import GrowthTracker from './components/GrowthTracker/GrowthTracker.jsx';
import MyToolkit from './components/MyToolkit/MyToolkit.jsx';
import Milestone from './components/Milestone.jsx';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/stocks" element={<Stocks />} />
      <Route path="/milestones" element={<Milestone />} />
      <Route path="/growth_tracker" element={<GrowthTracker />} />
      <Route path="/my_toolkit" element={<MyToolkit />} />
    </Routes>
  );
}

export default App;
